module.exports = __webpack_public_path__ + "img/subject4_07_106.jpg";